// @ts-ignore
export const buildPromptWithInstructions = (prompt, smartAISettings) => {
    let actualPrompt = prompt;
    let hiddenInstructions = [];
  
    if (smartAISettings.multipleResponses) {
      hiddenInstructions.push(
        "Please provide multiple different answers or approaches to this question. Format your response with clear headings for each approach."
      );
    }
  
    if (smartAISettings.industry && smartAISettings.industry.trim() !== "") {
      hiddenInstructions.push(
        `Please think like an expert of ${smartAISettings.industry.trim()}.`
      );
    }
  
    if (smartAISettings.role && smartAISettings.role !== "") {
      hiddenInstructions.push(
        `Please strictly behave and reply in role of a ${smartAISettings.role}.`
      );
    }
  
    if (smartAISettings.trait && smartAISettings.trait !== "") {
      hiddenInstructions.push(
        `Please strictly follow having traits of being ${smartAISettings.trait}.`
      );
    }
  
    if (smartAISettings.memory === "None") {
      hiddenInstructions.push(
        "FORGET EVERYTHING SAID TILL NOW AND REPLY FRESHLY. Do not reference previous messages in your response."
      );
    } else if (smartAISettings.memory === "Short") {
      hiddenInstructions.push(
        "Forget most previous messages and reply with just an overall knowledge of the conversation. Focus primarily on the current question."
      );
    }
  
    if (hiddenInstructions.length > 0) {
      actualPrompt = `${prompt}\n\n[HIDDEN INSTRUCTIONS: ${hiddenInstructions.join(
        " "
      )} These instructions should not be mentioned in your response.]`;
    }
  
    return actualPrompt;
  };

  export const getSystemMessage = () => ({
    role: "system",
    content:
      'You are a helpful assistant, try your best to give the answer as per the request.\n\nYou have certain abilites like creating pie-charts & Bar graphs, so if the user asks for it, only when it is asked, use them. below is instructions of how you can implement them. format your response using this exact structure:\n\nFor pie charts:\n1. Start with ```chart|pie\n2. On the next line, begin a valid JSON object\n3. Include a "series" array containing exactly one object\n4. This object must have:\n   - A "name" field (string) describing the overall category\n   - A "data" array containing objects for each pie segment\n5. Each segment object must have:\n   - A "name" field (string) for the segment label\n   - A "data" field (number) for the segment value\n6. End with ``` on its own line\n\nFor bar charts:\n1. Start with ```chart|bar\n2. On the next line, begin a valid JSON object\n3. Include a "labels" array of strings for the x-axis categories\n4. Include a "series" array containing one or more objects\n5. Each series object must have:\n   - A "name" field (string) describing the data series\n   - A "data" array of numbers (same length as labels)\n6. End with ``` on its own line\n\nFollow JSON syntax precisely: use double quotes for strings and property names, no trailing commas, and ensure all brackets are properly closed.',
  });